<script>
// import { Loading } from 'cube-ui'
import Loading from './spinner.vue'
import load from './load'
let timer
export default {
  components: {
    Loading
  },
  props: {
    topDistance: {
      type: Number,
      default: 70
    },
    bottomDistance: {
      type: Number,
      default: 50
    },
    maxDistance: {
      type: Number,
      default: 100
    },
    pullDownMethod: {},
    pullUpMethod: {},
    allLoaded: {
      type: Boolean,
      default: false
    },
    initialLoad: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      topStatus: 'ready',
      bottomStatus: 'ready',
      distanceIndex: 2,
      topStayTime: 200,
      translate: 0,
      bottomReached: false,
      ready: false
    }
  },
  computed: {
    transform () {
      const translate = this.translate < 0 ? 0 : this.translate
      return translate === 0 ? '' : `translate3D(0, ${translate}px, 0)`
    },
    rotate () {
      if (this.topStatus === 'loading') return ''
      const translate = this.translate < 0 ? 0 : this.translate
      let max = 100
      if (this.maxDistance > 0) {
        max = this.maxDistance
      }
      return { transform: `rotate(${translate / max}turn)`, animation: 'none' }
    },
    pullTopStyle () {
      return { height: this.topDistance + 'px', 'margin-top': -this.topDistance + 'px' }
    },
    topText () {
      switch (this.topStatus) {
        case 'done':
          return '加载完成'
        case 'fail':
          return '加载失败'
        default:
          return ''
      }
    }
  },
  methods: {
    onTouchstart (event) {
      this.startY = event.touches[0].clientY
      this.topStatus = 'ready'
      this.bottomStatus = 'ready'
      this.translate = 0
    },
    onTouchmove (event) {
      this.currentY = event.touches[0].clientY
      const distance = (this.currentY - this.startY) / this.distanceIndex
      if (distance > 0 && this.getScrollTop() === 0 && this.topStatus !== 'loading') {
        event.preventDefault()
        event.stopPropagation()
        if (this.maxDistance > 0) {
          this.translate = distance <= this.maxDistance ? distance : this.translate
        } else {
          this.translate = distance
        }
        this.topStatus = this.translate < this.topDistance ? 'pull' : 'trigger'
      }
      if (distance < 0) {
        this.translate = 0
      }
    },
    onTouchend (event) {
      if (this.translate > 0) {
        this.pullDown(event)
      }
    },
    async pullDown (event) {
      if (this.topStatus === 'trigger') {
        if (typeof this.pullDownMethod === 'function') {
          this.topStatus = 'loading'
          this.translate = this.topDistance
          try {
            load.toggle(true)
            await this.pullDownMethod()
            this.topStatus = 'done'
          } catch (e) {
            this.topStatus = 'fail'
            throw e
          } finally {
            load.toggle(false)
            timer = setTimeout(() => {
              this.translate = 0
            }, this.topStayTime)
          }
        } else {
          timer = setTimeout(() => {
            this.translate = 0
          }, this.topStayTime)
          this.topStatus = 'done'
        }
      } else {
        clearTimeout(timer)
        this.translate = 0
        this.topStatus = 'ready'
      }
    },
    async pullUp (event) {
      if (this.allLoaded || this.bottomStatus === 'loading') return
      if ((this.bottomReached || this.checkBottomReached()) && typeof this.pullUpMethod === 'function') {
        this.bottomStatus = 'loading'
        try {
          load.toggle(true)
          await this.pullUpMethod()
          this.bottomStatus = 'done'
        } catch (e) {
          this.bottomStatus = 'fail'
          throw e
        } finally {
          load.toggle(false)
          this.bottomReached = false
        }
      }
    },
    getScrollContainer () {
      let container = this.$el.parentNode
      while (container !== null && container !== document && (container.style.overflow !== 'scroll' || container.style.overflow !== 'auto')) {
        container = container.parentNode
      }
      return container
    },
    getScrollTop () {
      if (this.scrollContainer === document) {
        return document.documentElement.scrollTop || document.body.scrollTop || 0
      } else {
        return this.scrollContainer.scrollTop
      }
    },
    checkBottomReached () {
      const container = this.scrollContainer === document ? document.documentElement : this.scrollContainer
      const bottom = container.scrollHeight - this.getScrollTop() - container.clientHeight
      this.bottomReached = bottom <= (this.bottomDistance + 55)
      return this.bottomReached
    }
  },
  async mounted () {
    this.scrollContainer = this.getScrollContainer()
    if (this.initialLoad) {
      await this.pullDownMethod()
    }
    this.ready = true
    if (typeof this.pullUpMethod === 'function') {
      this.scrollContainer.addEventListener('scroll', this.pullUp)
      this.$once('hook:beforeDestroy', () => {
        clearTimeout(timer)
        this.scrollContainer.removeEventListener('scroll', this.pullUp)
      })
    }
  }
}
</script>

<template>
  <div
    class="pull_container"
    @touchstart.passive="onTouchstart"
    @touchmove="onTouchmove"
    @touchend="onTouchend"
    :style="{ transform }"
    v-show="ready"
  >
    <slot name="pullTop" v-if="pullDownMethod" :status="topStatus">
      <div class="pull_top" :style="pullTopStyle">
        <span v-show="topText">{{topText}}</span>
        <Loading
          v-show="topStatus !== 'fail' && topStatus !== 'done'"
          :stop="topStatus !== 'loading'"
          :style="rotate"
        ></Loading>
      </div>
    </slot>
    <slot></slot>
    <slot name="pullBottom" :status="bottomStatus" v-if="pullUpMethod" v-show="bottomStatus !== 'fail'">
      <div class="pull_bottom" :style="{ height: bottomDistance + 'px' }">
        <Loading v-show="bottomStatus === 'loading'"></Loading>
        <!-- <div v-show="bottomStatus === 'fail'">加载失败</div> -->
        <div v-show="allLoaded">没有更多内容</div>
      </div>
    </slot>
  </div>
</template>

<style lang="stylus">
.pull_container
  transition 0.2s

.pull_top, .pull_bottom
  display flex
  justify-content center
  align-items center

.pull_top
  position relative
  z-index -1
  padding-top 20px
</style>
